export * from './analytic.service';
import { AnalyticService } from './analytic.service';
export * from './analytic.serviceInterface'
export * from './application.service';
import { ApplicationService } from './application.service';
export * from './application.serviceInterface'
export * from './assign.service';
import { AssignService } from './assign.service';
export * from './assign.serviceInterface'
export * from './businessActivity.service';
import { BusinessActivityService } from './businessActivity.service';
export * from './businessActivity.serviceInterface'
export * from './category.service';
import { CategoryService } from './category.service';
export * from './category.serviceInterface'
export * from './change.service';
import { ChangeService } from './change.service';
export * from './change.serviceInterface'
export * from './comment.service';
import { CommentService } from './comment.service';
export * from './comment.serviceInterface'
export * from './contribution.service';
import { ContributionService } from './contribution.service';
export * from './contribution.serviceInterface'
export * from './delegate.service';
import { DelegateService } from './delegate.service';
export * from './delegate.serviceInterface'
export * from './device.service';
import { DeviceService } from './device.service';
export * from './device.serviceInterface'
export * from './export.service';
import { ExportService } from './export.service';
export * from './export.serviceInterface'
export * from './facebook.service';
import { FacebookService } from './facebook.service';
export * from './facebook.serviceInterface'
export * from './feedback.service';
import { FeedbackService } from './feedback.service';
export * from './feedback.serviceInterface'
export * from './image.service';
import { ImageService } from './image.service';
export * from './image.serviceInterface'
export * from './issue.service';
import { IssueService } from './issue.service';
export * from './issue.serviceInterface'
export * from './log.service';
import { LogService } from './log.service';
export * from './log.serviceInterface'
export * from './login.service';
import { LoginService } from './login.service';
export * from './login.serviceInterface'
export * from './logo.service';
import { LogoService } from './logo.service';
export * from './logo.serviceInterface'
export * from './member.service';
import { MemberService } from './member.service';
export * from './member.serviceInterface'
export * from './membership.service';
import { MembershipService } from './membership.service';
export * from './membership.serviceInterface'
export * from './operation.service';
import { OperationService } from './operation.service';
export * from './operation.serviceInterface'
export * from './organization.service';
import { OrganizationService } from './organization.service';
export * from './organization.serviceInterface'
export * from './person.service';
import { PersonService } from './person.service';
export * from './person.serviceInterface'
export * from './place.service';
import { PlaceService } from './place.service';
export * from './place.serviceInterface'
export * from './register.service';
import { RegisterService } from './register.service';
export * from './register.serviceInterface'
export * from './relationship.service';
import { RelationshipService } from './relationship.service';
export * from './relationship.serviceInterface'
export * from './report.service';
import { ReportService } from './report.service';
export * from './report.serviceInterface'
export * from './request.service';
import { RequestService } from './request.service';
export * from './request.serviceInterface'
export * from './reset.service';
import { ResetService } from './reset.service';
export * from './reset.serviceInterface'
export * from './review.service';
import { ReviewService } from './review.service';
export * from './review.serviceInterface'
export * from './reviewRequest.service';
import { ReviewRequestService } from './reviewRequest.service';
export * from './reviewRequest.serviceInterface'
export * from './state.service';
import { StateService } from './state.service';
export * from './state.serviceInterface'
export * from './tracking.service';
import { TrackingService } from './tracking.service';
export * from './tracking.serviceInterface'
export * from './transition.service';
import { TransitionService } from './transition.service';
export * from './transition.serviceInterface'
export * from './webhook.service';
import { WebhookService } from './webhook.service';
export * from './webhook.serviceInterface'
export const APIS = [AnalyticService, ApplicationService, AssignService, BusinessActivityService, CategoryService, ChangeService, CommentService, ContributionService, DelegateService, DeviceService, ExportService, FacebookService, FeedbackService, ImageService, IssueService, LogService, LoginService, LogoService, MemberService, MembershipService, OperationService, OrganizationService, PersonService, PlaceService, RegisterService, RelationshipService, ReportService, RequestService, ResetService, ReviewService, ReviewRequestService, StateService, TrackingService, TransitionService, WebhookService];
